const state = {
    cart: [],
    creatingDevis: false,
    codesDevis: [],
}


const actions = {

    /**
     * Service pour créer un devis.
     * @param {*} param0
     * @param {*} devisInfo
     * @returns
     */
    createDevis({
        commit
    }, devisInfo) {
        commit('setCreatingDevis', true)
        return new Promise((resolve, reject) => {
            axios.post('/api/devis', devisInfo).then(response => {
                commit('setCreatingDevis', false)
                commit('setDevisCode', response.data)
                resolve(response)
            }).catch(error => {
                commit('setCreatingDevis', false)
                reject(error)
            });
        });
    },

}

const getters = {
    cart: state => state.cart,
    creatingDevis: state => state.creatingDevis,
    codesDevis: state => state.codesDevis,
}

const mutations = {
    setCart(state, cart) {
        state.cart = cart;
    },
    setCreatingDevis(state, createDevis) {
        state.creatingDevis = createDevis
    },

    clearCart(state) {
        state.cart = [];
        localStorage.removeItem('cart');
        localStorage.removeItem('commentaire');
    },

    setDevisCode(state, codesDevis) {
        state.codesDevis = codesDevis
    },

    addArticle(state, article) {
        if (state.cart.length > 0) {
            let found = false
            state.cart.forEach(aArticle => {
                if (aArticle.idCommande === article.idCommande) {
                    aArticle.Nom = article.Nom
                    aArticle.Quantite = article.Quantite
                    aArticle.Commentaire = article.Commentaire
                    aArticle.CommentaireBronze = article.CommentaireBronze
                    aArticle.Options = article.Options
                    aArticle.PT = article.PT
                    aArticle.PU = article.PU
                    aArticle.Couleur = article.Couleur
                    aArticle.SocleChoose = article.SocleChoose
                    aArticle.sup = article.sup
                    aArticle.vinter = article.vinter
                    aArticle.bron = article.bron
                    aArticle.text = article.text
                    found = true
                }
            });
            if (!found) {
                state.cart.push(article);
            }
        } else {
            state.cart.push(article);
        }
        localStorage.setItem('cart', JSON.stringify(state.cart));
    },

    ArticleQuantityP(state, aIndex) {
        // Vérification que la quantité max ne soit pas atteinte
        if (!state.cart[aIndex].QuantiteMax || (state.cart[aIndex].QuantiteMax && state.cart[aIndex].QuantiteMax >= state.cart[aIndex].Quantite + 1)) {
            state.cart[aIndex].Quantite++;
            state.cart[aIndex].PT += parseFloat(state.cart[aIndex].PU);
            localStorage.setItem('cart', JSON.stringify(state.cart));
        }
    },

    ArticleQuantityM(state, aIndex) {
        state.cart[aIndex].Quantite -= 1;
        state.cart[aIndex].PT -= parseFloat(state.cart[aIndex].PU);
        localStorage.setItem('cart', JSON.stringify(state.cart));
    },

    ArticleQuantityS(state, infoQuantite) {
        // Vérification que la quantité max ne soit pas atteinte
        if (!state.cart[infoQuantite.index].QuantiteMax || (parseInt(state.cart[infoQuantite.index].QuantiteMax && state.cart[infoQuantite.index].QuantiteMax) >= infoQuantite.quantity)) {
            state.cart[infoQuantite.index].Quantite = infoQuantite.quantity;
            state.cart[infoQuantite.index].PT = state.cart[infoQuantite.index].Quantite * state.cart[infoQuantite.index].PU;
            localStorage.setItem('cart', JSON.stringify(state.cart));
        } else {
            state.cart[infoQuantite.index].Quantite = parseInt(state.cart[infoQuantite.index].QuantiteMax)
        }
    },

    removeArticle(state, aIndex) {
        state.cart.splice(aIndex, 1);
        localStorage.setItem('cart', JSON.stringify(state.cart));
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
